import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/auth";
import roomsReducer from "./reducers/rooms";
export default configureStore({
  reducer: {
    auth: authReducer,
    rooms: roomsReducer,
  },
});
